import { RapidsAutocomplete } from "@seo/rapids_autocomplete";
import $ from "cash-dom";
import { sendGAEvent } from "./analytics.js";
import IMask from "imask";

RapidsAutocomplete.setConfigs({
  apiKey: "2KCMNc4EEFJmMMDbhmru",
  apiUrl: "https://www.neighborwho.com/rpds/lookup",
  params: {
    maxResults: 5,
  },

  removeFocusAfterSelection: true,
});

function toBinary(string) {
  const codeUnits = Uint16Array.from(
    { length: string.length },
    (element, index) => string.charCodeAt(index),
  );
  const charCodes = new Uint8Array(codeUnits.buffer);

  let result = "";
  charCodes.forEach((char) => {
    result += String.fromCharCode(char);
  });
  return result;
}

function onSuggestionSelection(suggestion) {
  let encoded_address = encodeURIComponent(
    btoa(toBinary(suggestion.full_address)),
  );
  window.location.href =
    $("form.autocomplete").data("flow") + "address=" + encoded_address;
}

function onSuggestionSelectedStreetPage(suggestion, input) {
  if (input.classList.contains("street-page")) {
    const eventLabel =
      $("form.autocomplete big_header_mobile").data("event-label") ||
      suggestion.type;
    sendGAEvent({
      eventCategory: "Street_page_interaction",
      eventAction: "cta-click",
      eventLabel: eventLabel,
    });
    let encoded_address = encodeURIComponent(
      btoa(toBinary(suggestion.full_address)),
    );
    window.location.href =
      $("form.autocomplete").data("flow") +
      "address=" +
      encoded_address +
      "&search=" +
      suggestion.type;
    return;
  }

  onSuggestionSelection(suggestion);
}

function leadFormOnSuggestionSelection(suggestion) {
  $("#lead-form-address").val(suggestion.full_address);
}

$(document).ready(function () {
  const desktopInput = document.querySelector("#big-header form input");
  if (desktopInput) {
    new RapidsAutocomplete(desktopInput, {
      closeAfterScrollDown: true,
      onSuggestionSelected: function (suggestion) {
        onSuggestionSelectedStreetPage(suggestion, desktopInput);
      },
    });
  }

  const mobileInput = document.querySelector(
    "#big-header-mobile-expanded form input",
  );
  if (mobileInput) {
    new RapidsAutocomplete(mobileInput, {
      closeAfterScrollDown: true,
      onSuggestionSelected: function (suggestion) {
        onSuggestionSelectedStreetPage(suggestion, mobileInput);
      },
    });
  }

  const addressSearchRightRail = document.querySelector(
    "#address_cta_search input",
  );
  if (addressSearchRightRail) {
    new RapidsAutocomplete("#address_cta_search input");
  }
  const addressSearchWidgets = document.querySelectorAll(
    ".search_address input",
  );
  addressSearchWidgets.forEach((input) => {
    new RapidsAutocomplete(input);
  });

  const realEstateAgentForm = document.querySelector(
    "form.property-widget__lead_form",
  );
  if (realEstateAgentForm) {
    document.querySelectorAll(".input-phone-mask").forEach((input) => {
      IMask(input, {
        mask: "(000) 000-0000",
      });
    });
    new RapidsAutocomplete(
      realEstateAgentForm.querySelector('input[name="q"]'),
      { onSuggestionSelected: leadFormOnSuggestionSelection },
    );
  }
});
